import React from 'react';
import styles from './Loader.module.css';
const Loader = ({ flexStart, width }) => {
  return (
    <div
      className={styles['loader-container']}
      style={{ justifyContent: flexStart ? 'flex-start' : '' }}
    >
      <div
        className={`${styles['loader']}`}
        style={{ width: width, height: width }}
      ></div>
    </div>
  );
};

export default Loader;
